import Vue from 'vue';
import VueStash from 'vue-stash';
import moment from 'moment';
import { storageFactory } from 'storage-factory';
import * as R from 'ramda';

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

import VueResource from 'vue-resource';
import VueEvents from 'vue-events';
import Trend from 'vuetrend';

// Import F7 iOS Theme Styles
import 'framework7/css/framework7.bundle.css';
import Ionicons from 'ionicons/css/ionicons.min.css';
import SequentialEntrance from 'vue-sequential-entrance';

// Import App Custom Styles
import '../css/app.less';

/**
 * Workbox service work
 */
if (process.client && 'serviceWorker' in navigator) {
    if (process.env.NODE_ENV === 'production') {
        // already done elsewhere
        // navigator.serviceWorker.register('/service-worker.js');
    } else {
        navigator.serviceWorker.getRegistrations().then(function(registrations) {
            for (let registration of registrations) {
                registration.unregister();
            }
        });
    }
}

// Core
window.localStore = storageFactory(() => localStorage);
Array.prototype.move = function(from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
};

// Import App Component
import App from '../components/app.vue';
import store from './store';
import pck from '../../package.json';

window.store = store; // TODO: remove DEBUG only

// Init Vue Plugins
Framework7.use(Framework7Vue);
Vue.use(VueResource);
Vue.use(VueStash);
Vue.use(VueEvents);
Vue.use(Ionicons);
Vue.use(Trend);
Vue.use(SequentialEntrance);

// Init App
window.version = pck.version;
window.app = new Vue({
    el: '#app',
    components: {
        app: App
    },
    data: {
        store
    },
    methods: {},
    template: '<app/>'
});

window.Vue = Vue;
window.$$ = Framework7.$;
window.f7 = window.app.$f7;
window.moment = moment;
window.R = R;

// Show now to prevent flicker
document.getElementsByTagName('html')[0].style.visibility = 'visible';
// Fixes a flicker on page load TODO: remove
$$('#splash svg').css({
    opacity: 1
});
$$('.views').css({
    position: ''
});
setTimeout(() => {
    $$('.view').css({
        position: 'relative'
    });
}, 100);
